<template>
  <label class="checkbox" :data-qa="`checkbox-${id}-label-toggle`">
    <input
      :id="id"
      type="checkbox"
      class="checkbox-input"
      :checked="modelValue"
      @change="handleChange"
      :disabled="disabled"
      :data-qa="`checkbox-${id}-input-toggle`"
    />
    <span class="check-icon"></span>
    <span class="check-label">{{ label }}</span>
  </label>
</template>

<script lang="ts" setup>
interface Props {
  modelValue: boolean;
  id: string;
  label: string;
  disabled?: boolean;
}

defineProps<Props>();
const emit = defineEmits(["update:modelValue"]);

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("update:modelValue", target.checked);
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  cursor: pointer;
  max-width: fit-content;

  &:has(:disabled) {
    cursor: default;
    pointer-events: none;
  }

  input {
    display: none;
  }

  span {
    font-weight: 500;
    font-size: 13px;
    line-height: 1.5;
    letter-spacing: 0;
    text-align: left;
  }

  input:checked ~ .check-icon::before {
    opacity: 1;
  }

  input:checked:disabled ~ .check-icon {
    border-color: #cccccc;
    pointer-events: none;

    &::before {
      opacity: 1;
      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxOCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNTQ5NjEgMTEuODc1TDAuODQ5NjA5IDYuMTc0OThMMS45OTk2MyA1LjAyNDk1TDYuNTQ5NjYgOS41NzQ5OEwxNS45OTk2IDAuMTI0OTk5TDE3LjE0OTYgMS4yNzQ5OEw2LjU0OTYxIDExLjg3NVoiIGZpbGw9IiNDQ0NDQ0MiLz4KPC9zdmc+Cg==");
    }
  }

  &:hover .check-icon {
    border-color: rgba(48, 168, 255, 1);
  }
}

.check-icon {
  width: 20px;
  min-width: 20px;
  height: 20px;
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 3px;
  background-color: transparent;
  margin-right: 8px;
  position: relative;
  transition: border-color 0.15s ease;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    width: 18px;
    height: 12px;
    background-repeat: no-repeat;
    transition: opacity 0.15s ease;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxOCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNTQ5NjEgMTEuODc1TDAuODQ5NjA5IDYuMTc0OThMMS45OTk2MyA1LjAyNDk1TDYuNTQ5NjYgOS41NzQ5OEwxNS45OTk2IDAuMTI0OTk5TDE3LjE0OTYgMS4yNzQ5OEw2LjU0OTYxIDExLjg3NVoiIGZpbGw9IiMzMEE4RkYiLz4KPC9zdmc+Cg==");
    opacity: 0;
  }
}

.check-body {
  display: block;
  color: #888888;
}
</style>
